










































































































































































import Countdown from 'components/Countdown.vue'
import LanguageSwitcher from 'components/LanguageSwitcher.vue'
import OAuth from 'components/OAuth.vue'
import { QForm } from 'quasar'
import { getPasswordColor, getPasswordProgress } from 'src/helpers'
import { Component, Vue } from 'vue-property-decorator'

// const BgAnimation = () => import('components/BgAnimation.vue')

@Component({
  components: {
    Countdown,
    // BgAnimation,
    LanguageSwitcher,
    OAuth
  }
})
export default class Login extends Vue {
  username: string = ''

  email: string = ''

  tel: string = ''

  password: string = ''

  passwordTest: string = ''

  isHiddenPassword: boolean = true

  userAgreement: boolean = false

  privacyPolicy: boolean = false

  errors: Record<string, string[]> = {}

  loading: boolean = false

  submitted: boolean = false

  redirectUrl: string | null = null

  done: boolean = false

  get passwordLevel () {
    return getPasswordProgress(this.password)
  }

  get passwordLevelColor () {
    return getPasswordColor(this.passwordLevel)
  }

  get challenge () {
    return this.$route.query.login_challenge
  }

  submitForm () {
    this.submitted = true
    this.errors = {}

    if (!this.userAgreement) {
      this.$q.notify({
        position: 'top',
        color: 'negative',
        message: this.$t(this.$msg.TosRequiredError) as string
      })
    } else if (!this.privacyPolicy) {
      this.$q.notify({
        position: 'top',
        color: 'negative',
        message: this.$t(this.$msg.PolicyRequiredError) as string
      })
    } else {
      (this.$refs.registerForm as QForm).validate().then((success) => {
        if (success) {
          const csrfToken = this.$q.cookies.get('xsrf')
          const { username, tel, email, password } = this
          const formData = {
            username,
            tel: tel ? `+7${tel.replace(/\D/g, '')}` : '',
            email,
            password,
            challenge: this.challenge,
            _csrf: csrfToken
          }
          const headers = { 'CSRF-Token': csrfToken }

          this.loading = true

          this.$axios.post('/register', formData, { headers, withCredentials: true })
            .then(async ({ data }) => {
              if (data.ok) {
                this.errors = {};
                (this.$refs.registerForm as QForm).resetValidation()
                this.redirectUrl = data.redirectUrl || null
                this.done = true
              } else if (data.errors) {
                this.errors = data.errors
                await (this.$refs.registerForm as QForm).validate()
              }
            }).catch((e) => {
            this.errors = {
              network: e.message
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }

  handleKeyupTel () {
    this.tel = this.tel.replace(/^\D*[78]/g, '')
  }

  handlePasteTel (e: any) {
    const tel = e.clipboardData.getData('text').replace(/\D/g, '').replace(/^(\+?7|8)/, '')
    setTimeout(() => {
      this.tel = tel
    }, 0)
  }

}
